import { useState, useEffect } from 'react';

export const DEFAULT_INTERVAL_MS = 5000;

type ReturnType = [number, (value: number) => void, (value: number) => void];

export function useAutoScroll(
    itemsCount: number,
    stopScrollOnClick = true,
    interval: number = DEFAULT_INTERVAL_MS
): ReturnType {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [clicked, setClicked] = useState(false);

    const setCurrentIndexOnClick = (index: number) => {
        setClicked(true);
        setCurrentIndex(index);
    };

    useEffect(() => {
        if (clicked && stopScrollOnClick) {
            return;
        }

        const isLastItem = itemsCount === currentIndex + 1;

        const timer = setTimeout(() => {
            setCurrentIndex(isLastItem ? 0 : currentIndex + 1);
        }, interval);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex]);

    return [currentIndex, setCurrentIndexOnClick, setCurrentIndex];
}
